import ContainerFlex from "components/ContainerFlex";
import * as St from "./styles";
import { useEffect, useState } from "react";
import AppButton from "components/AppButton/AppButton";
import { RouteNames } from "routes/routes";
import { useHistory, useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/app/hooks";
import useApi, { ApiMethod } from "hooks/useApi";
import Endpoints from "services/api/endpoints";
import { addTypeFlowState } from "redux/features/security/security-slice";
import { showMessage } from "utils/messages";
import { setLoading, setTitleLoading } from "redux/ui/loadings-slice";
import { moneyMask } from "utils/mask";
import { LOCAL_STORE_ID_LOJA } from "../../../../constants";
import { useSelector } from "react-redux";
import { selectAntecipationList } from "redux/features/cliente/cliente-slice";
import moment from "moment";

const PagarPix = (props: any) => {
  const [qrCode, setQrCode] = useState<any>({
    base64: "",
    txid: "",
    emv: "",
  });
  const [status, setStatus] = useState("");

  const history = useHistory();
  const dispatch = useAppDispatch();
  const { state } = useLocation<any>();
  const { idFatura } = state;
  const { idLoja } = useAppSelector((state) => state.security);
  const idLojaStorge = localStorage.getItem(LOCAL_STORE_ID_LOJA);
  const storeID = idLoja || idLojaStorge;

  const antecipationList = useSelector(selectAntecipationList) || [];

  const {
    cliente: { faturaList, nome, paymentInvoice, valueAntecipationPurchase, cpf },
  } = useAppSelector((state) => state.cliente);

  const clickBack = () => {
    state.antecipation || state.historyAntecipation
      ? history.push(RouteNames.ATENDIMENTO_ANTECIPACAO)
      : history.push(RouteNames.ATENDIMENTO_FATURA);
    dispatch(addTypeFlowState("fatura"));
  };

  const clickNext = () => {
    history.push(RouteNames.COMPROVANTE_PAGAMENTO_PIX, {
      txid: qrCode?.txid,
      idFatura: faturaList?.data?.id_fatura,
      antecipation: state?.antecipation,
    });
  };

  const GetQrCode = useApi<any>(
    Endpoints.cobranca.getQRCode.replace("PARAM_ID_FATURA", paymentInvoice?.id || ""),
    ApiMethod.GET
  );
  const POSTBeginPixPayment = useApi<any>(
    Endpoints.pagamentos.postMakePaymentInvoicePix,
    ApiMethod.POST
  );

  const PostQrCodeAntecipation = useApi<any>(
    Endpoints.cobranca.generatePixAntecipation,
    ApiMethod.POST
  );

  const PostCreateAntecipation = useApi<any>(
    Endpoints.cobranca.postCreateAntecipationPurchase,
    ApiMethod.POST
  );

  useEffect(() => {
    if (!qrCode?.txid && !state?.txId) return;
    let timeout: any;
    const socket = new WebSocket(
      Endpoints.cobranca.getStatusPixPayment.replace(
        "PARAM_ID_TX",
        qrCode?.txid || state?.txId
      )
    );
    socket.onopen = (e) => {
      console.log("socket open", e);
    };

    socket.onmessage = (data) => {
      if (data.data === "_ready_") return;
      const parsed = JSON.parse(data.data);

      if (parsed.status === "SUCESSO") {
        setStatus("SUCESSO");
        socket.close();
        clearTimeout(timeout);
      }
      if (parsed.status === "ERRO") {
        setStatus("ERRO");
        showMessage("warning", "Atenção!", parsed?.mensagem as string, {
          willClose: () => {
            window.location.href = RouteNames.HOME;
          },
        });
        socket.close();
      }
    };
    socket.onerror = (ev) => {
      console.error("erro no ws.", ev);
      socket.close();
    };

    const startListening = () => {
      timeout = setTimeout(() => {
        console.log("Tempo de 180 segundos atingido, encerrando conexão...");
        console.log("closed");

        socket.close();
        showMessage(
          "warning",
          "Atenção!",
          "Procure um operador para verificar sobre o teu comprovante" as string,
          {
            willClose: () => {
              window.location.href = RouteNames.HOME;
            },
          }
        );
      }, 180000);
    };

    startListening();

    return () => {
      if (socket) {
        socket.close();
      }
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [qrCode?.txid, state?.txId]);

  const requestAntecipation = async (qrCodeData?: any) => {
    dispatch(setLoading(true));
    dispatch(setTitleLoading("Solicitando antecipação..."));

    const payload: any[] = [];

    antecipationList?.forEach((item: any) => {
      payload.push({
        cartao: item.cartao,
        dataCompra: item.dataCompra,
        cpf: item.cpf,
        email: item.email,
        dataFechamento: String(moment(item?.dataCorte).format("YYYY-MM-DD")),
        id_fatura: item.idFatura,
        idParcelamento: item.idCompra,
        nomeCliente: item.nomeCompleto,
        parcelasAntecipadas: item.qtdParcelasAPagar,
        valorAntecipacao: item?.valorPendente,
        tipoAntecipacao: "COMPRA",
        origemAntecipacao: "TOTEM",
        qrcodeBase64: qrCodeData?.base64,
        txId: qrCodeData?.txid,
        pixCopiaECola: qrCodeData?.emv,
      });
    });

    const responseData = await PostCreateAntecipation.callApi(payload);

    if (responseData.status >= 200 && responseData.status < 300) {
      dispatch(setLoading(false));
    } else {
      dispatch(setLoading(false));
      const { mensagem } = responseData.data;
      showMessage("warning", "Atenção!", mensagem as string);
      history.push(RouteNames.ATENDIMENTO_ANTECIPACAO);
    }
  };

  const getQrCodeAntecipation = async () => {
    dispatch(setLoading(true));
    dispatch(setTitleLoading("Gerando QR Code..."));

    const payload = {
      cpf: cpf,
      valor: valueAntecipationPurchase || 0,
    };

    try {
      const response = await PostQrCodeAntecipation.callApi(payload);

      if (response.status >= 200 && response.status <= 300) {
        const data = response?.data;
        setQrCode(data);
        dispatch(setLoading(false));
        await requestAntecipation(data);
      } else {
        dispatch(setLoading(false));
        const { mensagem } = response.data;
        showMessage("warning", "Atenção!", mensagem as string);
        history.push(RouteNames.ATENDIMENTO_ANTECIPACAO);
      }
    } catch (error) {
      console.log(error);
      dispatch(setLoading(false));
      showMessage("warning", "Atenção!", "Tente novamente mais tarde!");
      history.push(RouteNames.ATENDIMENTO_ANTECIPACAO);
    }
  };

  const getQrCode = async () => {
    dispatch(setLoading(true));
    dispatch(setTitleLoading("Gerando QR Code..."));
    try {
      const response = await GetQrCode.callApi();
      if (response.status >= 200 && response.status <= 300) {
        setQrCode(response.data);
        await beginPixPayment();
      } else {
        dispatch(setLoading(false));
        const { mensagem } = response.data;
        showMessage("warning", "Atenção!", mensagem as string);
        history.push(RouteNames.ATENDIMENTO_FATURA);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const beginPixPayment = async () => {
    try {
      const response = await POSTBeginPixPayment.callApi({
        cpfTitular: cpf,
        id_fatura: paymentInvoice?.id_fatura,
        nomeTitular: nome,
        tipoPagamento: "PIX",
        valorPago: Number(faturaList?.data.saldo_devedor),
        origem: "TOTEM",
        idLoja: storeID,
        // TROCAR ID LOJA POR STORE ID ANTES DA GMUD
        // idLoja: storeID,
        // valorTaxaServico,
        // valorTaxaJuros,
        // taxaJuros,
        // taxaServico,
      });
      if (response.status >= 400) {
        dispatch(setLoading(false));
        const { mensagem } = response.data;
        showMessage("warning", "Atenção!", mensagem as string);
        history.push(RouteNames.ATENDIMENTO_FATURA);
        return false;
      }
      dispatch(setLoading(false));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (paymentInvoice?.id && !state.antecipation) {
    getQrCode();
    }

    if (state.antecipation && !state?.historyAntecipation) {
      getQrCodeAntecipation();
      dispatch(addTypeFlowState("fatura-pix"));
    }

    if (state?.historyAntecipation) {
      dispatch(addTypeFlowState("fatura-pix"));
    }
    // getQrCode/getQrCodeAntecipation vem de useApi/e nao sao memoizadas; incluir
    // causaria refetch em loop a cada render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idFatura, state, paymentInvoice, dispatch]);

  return (
    <ContainerFlex>
      <St.TitleH1>Pagar com pix</St.TitleH1>
      <ContainerFlex>
        <ContainerFlex center>
          <St.SpanSubtitle>
            {state.antecipation || state?.historyAntecipation
              ? `O valor da sua antecipação é de ${moneyMask(
                      valueAntecipationPurchase
                )}`
              : `O saldo devedor da tua Fatura é de R$
            ${moneyMask(faturaList?.data.saldo_devedor)}`}
          </St.SpanSubtitle>
          <St.SpanDescription>
            {state.antecipation || state?.historyAntecipation
              ? "Escanear o QR Code para pagar tua antecipação"
              : "Escanear o QR Code para pagar tua Fatura."}
          </St.SpanDescription>
          <ContainerFlex center padding={30}>
            <St.QrCodeImage src={`data:image/png;base64, ${qrCode.base64 || state.qrcodeBase64}`} />
          </ContainerFlex>
          <ContainerFlex center marginTop={10}>
            <St.SpanDescription>
              {`Atenção! QR Code disponível na tela por ${props.timer} segundos.`}
            </St.SpanDescription>
          </ContainerFlex>
        </ContainerFlex>
      </ContainerFlex>
      <ContainerFlex center horizontal row space>
        <AppButton
          content="Voltar"
          route={
            (antecipationList?.length ?? 0) > 0 || state?.historyAntecipation
              ? RouteNames.ATENDIMENTO_ANTECIPACAO
              : RouteNames.ATENDIMENTO_FATURA
          }
          outlined={true}
          click={clickBack}
        />
        <AppButton
          content="Comprovante"
          click={clickNext}
          disabled={status !== "SUCESSO"}
        />
      </ContainerFlex>
    </ContainerFlex>
  );
};

export default PagarPix;
